import React from "react";
import { Link } from "react-router-dom"; // React Router ile yönlendirme

const BlogCard = ({ id, title, content, date, image }) => {
  return (
    <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow overflow-hidden">
      <img src={image} alt={title} className="w-full h-48 object-cover" />
      <div className="p-4">
        <h3 className="text-xl font-semibold text-gray-800">{title}</h3>
        <p className="text-gray-600 text-sm mt-2">{content}</p>
        <p className="text-gray-500 text-xs mt-2">{date}</p>
        <Link
          to={`/blog/${id}`} // Dinamik yönlendirme için blog id kullanıldı
          className="text-blue-600 hover:underline mt-4 inline-block"
        >
          Devamını Oku
        </Link>
      </div>
    </div>
  );
};

export default BlogCard;
